import type { FC } from 'react';
import { PapiGallection } from '@wix/da-papi-types';
import FolderHeaderMobile from '../../../stash/FolderHeaderMobile';
import DefaultLayout from '../DefaultLayout';

export interface Props {
  folder: PapiGallection;
  isRootStashFolder?: boolean;
  copyFolderLink: (folder: PapiGallection) => void;
}

const GallectionLayout: FC<Props> = ({ folder, isRootStashFolder, copyFolderLink }) => {
  if (isRootStashFolder) {
    return <DefaultLayout />;
  }

  return <FolderHeaderMobile folder={folder} onShareClick={() => copyFolderLink(folder)} isOwner />;
};
GallectionLayout.displayName = 'GallectionLayout';

export default GallectionLayout;
